var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1014 13.1778C14.1014 14.1207 13.3321 14.8871 12.3872 14.8871H3.67195C2.72768 14.8871 1.95907 14.1207 1.95907 13.1778V4.48118C1.95907 3.53827 2.72768 2.7713 3.67195 2.7713H6.36959V0.816406H3.67195C1.64693 0.816406 0 2.45982 0 4.48118V13.1778C0 15.1992 1.64693 16.842 3.67195 16.842H12.3872C14.4129 16.842 16.0605 15.1992 16.0605 13.1778V10.4847H14.1014V13.1778Z",
    fill: "#3C7AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5936 2.7085L14.1663 0.286392C13.7836 -0.0954639 13.1639 -0.0954639 12.7812 0.286392L6.11388 6.9415C5.9898 7.06465 5.90099 7.21974 5.85724 7.38917L5.01549 10.6512C4.92864 10.9862 5.02659 11.342 5.27213 11.5863C5.45759 11.772 5.70835 11.8724 5.96499 11.8724C6.04596 11.8724 6.12824 11.862 6.20856 11.8411L9.4776 11.0012C9.64739 10.9581 9.80215 10.8695 9.92623 10.7451L16.5936 4.09061C16.7771 3.9075 16.8803 3.65923 16.8803 3.39923C16.8803 3.13923 16.7778 2.89226 16.5936 2.7085ZM8.72924 9.17398L7.32654 9.53433L7.68766 8.13463L13.4741 2.36053L14.5163 3.40053L8.72924 9.17398Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePencil);
export default __webpack_public_path__ + "static/media/blue-pencil.4aff03711cf6e36085ac3c8447aed54f.svg";
export { ForwardRef as ReactComponent };